import numeral from 'numeral'

import { Text } from '@mxenabled/mxui'

import { GridCellParams } from '@mui/x-data-grid'

const GeneratedRowCell = (params: GridCellParams) => (
  <Text sx={{ p: 16, textAlign: 'center', width: '100%' }} variant="body2">
    {numeral(params.row.final_generated_count).format('0a')}
  </Text>
)

export default GeneratedRowCell
